export const Actions = {
    Call: 'call',
    RemoteAppointment: 'remote-appointment',
    DealershipAppointment: 'dealership-appointment',
    Question: 'question',
};
